const NotFoundPage = () => (
  <div className="h-100 w-100 p-3">
    <h3>
      <strong>Not Found</strong>
    </h3>
    <p>The requested page could not be found.</p>
  </div>
);

export default NotFoundPage;
